import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ColumnFields } from '../../utils/dataTable/data';
import { RootState } from '../rootReducer';

export interface AccountViewState {
  fields: ColumnFields;
}

export const initialState: AccountViewState = {
  fields: {}
};

const getAccountsViewState = (state:RootState): AccountViewState => state.adminDashboard.accounts;
const getAccountsDashboardFields = (state: RootState): ColumnFields => getAccountsViewState(state).fields;

export const selectors = {
  getAccountsDashboardFields
};

const accountsViewSlice = createSlice({
  name: 'accountsViewAdminDashboard',
  initialState,
  reducers : {
    setAccountsDashboardFields: (state: AccountViewState, action: PayloadAction<ColumnFields>) => {
      state.fields = action.payload;
    }
  }
});

export const actions = { ...accountsViewSlice.actions };
export default accountsViewSlice.reducer;

